import React, { memo, useState } from "react";
import { Controller } from "react-hook-form";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { TextField, Box } from "@mui/material";
import { format, parseISO, isValid } from "date-fns";
import RequiredTitle from "./RequiredTitle";

const DatePickerField = ({ input, control, error, defaultValue }) => {
  const {
    name,
    type,
    label,
    validation,
    alignment = {},
    defaultValues = defaultValue,
    range = false,
    ...rest
  } = input;
  const { sm = 12, md = 12, lg = 12 } = alignment;
  const [rangeSelected, setRangeSelected] = useState({ from: null, to: null });

  const handleRangeChange = (date) => {
    if (rangeSelected.from && date < rangeSelected.from) {
      setRangeSelected({ from: date, to: null });
    } else {
      setRangeSelected({ ...rangeSelected, to: date });
    }
  };

  return (
    <div
      key={name}
      className={`form-group mb-3 col-sm-${sm} col-md-${md} col-lg-${lg}`}
    >
      <RequiredTitle
        label={label}
        validation={validation}
      />
      <Controller
        name={name}
        control={control}
        rules={validation}
        defaultValue={defaultValues}
        render={({ field }) => (
          <div>
            {range ? (
              <DayPicker
                selected={rangeSelected}
                onDayClick={handleRangeChange}
                mode="range"
                {...rest}
              />
            ) : (
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Box>
                  <DatePicker
                    value={
                      field.value
                        ? isValid(parseISO(field.value))
                          ? parseISO(field.value)
                          : null
                        : null
                    }
                    onChange={(date) => {
                      if (date && isValid(date)) {
                        const formatted = format(date, "yyyy-MM-dd");
                        field.onChange(formatted);
                      } else {
                        field.onChange(null);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        fullWidth
                      />
                    )}
                    {...rest}
                  />
                </Box>
              </LocalizationProvider>
            )}
            {error && <div className="invalid-feedback">{error}</div>}
          </div>
        )}
      />
    </div>
  );
};

export default memo(DatePickerField);
